:host {
    --uui-button-tabs-first-tab-radius: 4px 0 0 4px;
    --uui-button-tabs-last-tab-radius: 0px 4px 4px 0;
}

:host{
    display: flex;
    justify-content: flex-start;
}

::slotted(uui-button-tab) {
    flex-grow: 1;
    flex-basis: 0;
    flex-shrink: 0;
}

::slotted(uui-button-tab:first-child) {
    --uui-button-tab-border-radius: var(--uui-button-tabs-first-tab-radius);
    --uui-button-tab-border-left: 1px;
}

::slotted(uui-button-tab:last-child) {
    --uui-button-tab-border-radius: var(--uui-button-tabs-last-tab-radius);
}